module.exports = __webpack_public_path__ + "img/no-image-400x400.8a6fa43f.png";